// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>VA offers an urgent care benefit that provides Veterans with greater choice and access to timely, high-quality care. Urgent care providers treat injuries and illnesses that require immediate attention but are not life-threatening. The Urgent Care Eligibility API allows a Veteran to determine if they are eligible to receive urgent care from a community provider.</p>
      <p>For a Veteran to be eligible to receive urgent care, a Veteran must meet ALL the following criteria:</p>
      <ul>
      <li>Be enrolled in the VA health care system; and</li>
      <li>Have received care through VA from either a VA Medical Center or community provider within the past 24 months</li>
      </ul>
      <p>The Urgent Care Eligibility API uses VA’s Enrollment and Eligibility system to determine a Veteran's eligibility and displays the information in a FHIR format, using HL7's FHIR R4 CoverageEligibilityResponse resource. Please see the FHIR <a href="https://www.hl7.org/fhir/r4/coverageeligibilityresponse.html">CoverageEligibilityResponse</a> page for more information on this resource.</p>
    </div>
  );
};

export default MarkdownComponent;
